import {
  PAGE_EDIT_ORGANIZATION_STAFF,
  PAGE_NEW_ORGANIZATION_STAFF,
  PAGE_ORGANIZATION_CHART,
  PAGE_ORGANIZATION_STAFF
} from "../../pages/Organization/routes";
import { PERMISSION_VIEW_ORG_CHART, PERMISSION_VIEW_ORG_STAFF } from "./permissions/permissions";

/** Organisation module — org chart and staff management. */
export const NAV_ORG = {
  key: "org",
  name: "container.sidebar.org",
  iconClassName: "ti-pulse",
  gates: [PERMISSION_VIEW_ORG_CHART, PERMISSION_VIEW_ORG_STAFF],
  submenu: [
    {
      key: "org.organisational_chart",
      name: "container.sidebar.organisational_chart",
      path: PAGE_ORGANIZATION_CHART,
      gates: PERMISSION_VIEW_ORG_CHART
    },
    {
      key: "org.staff",
      name: "container.sidebar.staff",
      path: PAGE_ORGANIZATION_STAFF,
      gates: PERMISSION_VIEW_ORG_STAFF,
      activeRoutes: [PAGE_NEW_ORGANIZATION_STAFF, PAGE_EDIT_ORGANIZATION_STAFF]
    }
  ]
};
